import {Component, ContentChild, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {OrganizationChart} from 'primeng/organizationchart';
import {TreeNode} from 'primeng/api';

@Component({
  selector: 'si-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrgChartComponent implements OnInit {
  @Input() id: string;
  @ContentChild(OrganizationChart, {static: true}) pOrganizationChart: OrganizationChart;
  private _model: any[];

  constructor() {
  }

  get model(): any[] {
    return this._model;
  }

  /**
   * @param val: any[] Array of tree nodes to display.
   * Use this Input() instead of the p-organizationChart value attribute to avoid errors.
   */
  @Input()
  set model(val) {
    this._model = val;
    this.setValue(this.parseToTreeNode(val));
  }

  ngOnInit(): void {
  }

  setValue(newValue: any[]): void {
    if (!newValue) {
      newValue = [];
    }

    newValue = [...newValue];
    this.pOrganizationChart.value = newValue;
  }

  parseToTreeNode(nodes: any[], parentNode?: TreeNode): TreeNode[] {
    if (!nodes || !nodes.length) {
      return [];
    }

    const treeNode = [...nodes].map(node => {
      const auxNode = {
        data: node,
        label: node.label,
        leaf: !node.children?.length,
        expanded: node.expanded,
        parent: parentNode
      } as TreeNode;

      if (node.type) {
        auxNode.type = node.type;
      }

      if (node.styleClass) {
        auxNode.styleClass = node.styleClass;
      }

      if (node.children) {
        auxNode.children = this.parseToTreeNode(node.children, auxNode);
      }

      return auxNode;
    });

    return treeNode;
  }
}
